import { SVGProps } from 'react';

export const RangeOperatorGreaterThanOrEqual = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    width="10"
    height="15"
    viewBox="0 0 10 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.91016 14.0098H0V11.9688H9.91016V14.0098ZM9.75391 4.02832V6.09082L0.366211 10.1299V7.60059L7.11133 5.04297L0.366211 2.53027V0L9.75391 4.02832Z"
      fill="currentColor"
    />
  </svg>
);
